import { render } from "./EditOptions.vue?vue&type=template&id=4b9138ac&scoped=true"
import script from "./EditOptions.vue?vue&type=script&lang=js"
export * from "./EditOptions.vue?vue&type=script&lang=js"

import "./EditOptions.vue?vue&type=style&index=0&id=4b9138ac&scoped=true&lang=css"

import exportComponent from "/builds/coditas-projects/dialog360-whatsapp/frontend/whatsapp-exotel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b9138ac"]])

export default __exports__